<template>
  <v-container grid-list-md>
    <h2 class="mt-3">Privacy Policy</h2>    
    <p class="mt-2 mb-5 detail">
    When you sign up to hear back from us via email, we keep track of your email address using SendInBlue, a service that helps us reach out to you through email (their privacy policy is located <a href='https://blog.sendinblue.com/privacypolicy/'>here</a>.)
    <br>
    Additionally, we may collect information on site usage and other statistics for site management and upkeep.
    </p>
    <h2 class="mt-3">Cookie Policy</h2> 
    <p class="mt-2 mb-5 detail">
      We may use cookies for site analytics, etc.
      Additionally, links leading away from this site (for example, our email signup service) may use cookies to keep track of usage statistics for our third-party services. For more information about cookies used by those third-party services:
      <ul>
        <li><a href="https://www.sendinblue.com/legal/cookies/">https://www.sendinblue.com/legal/cookies/</a></li>
        <li><a href="https://www.sendinblue.com/legal/privacypolicy/">https://www.sendinblue.com/legal/privacypolicy/al/cookies/</a></li>
        <li><a href="https://www.amazon.com/gp/help/customer/display.html?nodeId=201909010">https://www.amazon.com/gp/help/customer/display.html?nodeId=201909010</a></li>
        <li><a href="https://www.amazon.com/gp/help/customer/display.html?nodeId=201890250">https://www.amazon.com/gp/help/customer/display.html?nodeId=201890250</a></li>
        <li><a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a></li>
        <li><a href="https://www.sheetmusicplus.com/help/privacy-policy">https://www.sheetmusicplus.com/help/privacy-policy</a></li>
      </ul>
      <br>
      By clicking on links to those services, you accept that cookies from those third-parties may be used resulting from clicking.
    </p>
    
    <h2 class="mt-3">Disclosure</h2>  
    <p class="detail">
      Links for our products go to our Amazon or other product listings.<br>
      As an Amazon Associate we earn from qualifying purchases.<br>
      As a Sheet Music Plus Affiliate we earn from qualifying purchases.
    </p>
    <br>
    <br>
    <br>
    <br>
  </v-container>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  data: () => ({})
};
</script>

<style>
.detail{
  font-size: 16px;
}
li{
  margin-top: 5px;
}
</style>
